import { useState, useRef, useEffect } from "react";
import AvisoDePrivacidad from "./aviso";
import Terminos from "./terminos";
import { useDispatch, useSelector } from "react-redux";
import { setUser, toogleLoad } from "../redux/slices/appslice";
import { aceptaTerminosYCondiciones } from "../ws";
import { useAnalytics } from '../AnalyticsContext'
import { logEvent } from "firebase/analytics";
import M from 'materialize-css';

function ModalTC() {

    const analytics = useAnalytics();
    const dispatch = useDispatch();
    const appData = useSelector((state) => state.appData)
    const [optSelected, setOpt] = useState(1);
    const [cargando, setCargando] = useState(false);
    const [aceptoAviso, setAceptoAviso] = useState(false);
    const [aceptoTerminos, setAceptoTerminos] = useState(false);
    const [scrolledAviso, setScrolledAviso] = useState(false);
    const [scrolledTerminos, setScrolledTerminos] = useState(false);
    const contentRef = useRef(null);

    const resetState = () => {
        setOpt(1);
        setAceptoAviso(false);
        setAceptoTerminos(false);
        setScrolledAviso(false);
        setScrolledTerminos(false);
        setCargando(false);
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
        setTimeout(() => {
            if (contentRef.current) {
                contentRef.current.scrollTop = 0;
            }
        }, 50);
    };

    useEffect(() => {
        const modalElem = document.getElementById('modalTC');
        const handleModalOpen = () => {
            resetState();
        };

        if (modalElem) {
            modalElem.addEventListener('modalTCOpen', handleModalOpen);
        }

        return () => {
            if (modalElem) {
                modalElem.removeEventListener('modalTCOpen', handleModalOpen);
            }
        };
    }, []);

    useEffect(() => {
        resetState();
    }, [appData?.user]);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 35) {
            if (optSelected === 1) {
                setScrolledAviso(true);
            } else if (optSelected === 2) {
                setScrolledTerminos(true);
            }
        }
    };

    const handleTabChange = (opt) => {
        setOpt(opt);
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
    };

    useEffect(() => {
        const checkScroll = () => {
            if (contentRef.current) {
                const { scrollHeight, clientHeight } = contentRef.current;
                if (scrollHeight > 0 && scrollHeight <= clientHeight + 35) {
                    if (optSelected === 1) {
                        setScrolledAviso(true);
                    } else if (optSelected === 2) {
                        setScrolledTerminos(true);
                    }
                }
            }
        };
        const timer = setTimeout(checkScroll, 400);
        return () => clearTimeout(timer);
    }, [optSelected, appData]);

    async function aceptarTerminos() {
        try {

            setCargando(true);
            dispatch(toogleLoad(true))
            let resultAceptaTC = await aceptaTerminosYCondiciones(appData);

            if (resultAceptaTC) {

                logEvent(analytics, "Login_aviso_acepto", {
                    screen_name: "Login",
                });


                logEvent(analytics, "Login_terminos_acepto", {
                    screen_name: "Login",
                });
                const modalTC = M.Modal.getInstance(document.getElementById('modalTC'));
                if (modalTC) {
                    modalTC.close();
                }
                resetState();
                if (appData.user.UsuarioPV) {
                    M.Modal.init(document.getElementById('modalPV'), {
                        dismissible: false
                    });
                    M.Modal.getInstance(document.getElementById('modalPV')).open();
                }
            } else {
                M.toast({ html: 'No se logro actualizar la información intente mas tarde.', classes: 'red accent-4 white-text txtBold' })
            }

            setCargando(false);
            dispatch(toogleLoad(false))
        } catch (error) {
            setCargando(false);
            dispatch(toogleLoad(false))
        }
    }

    return (
        <div id="modalTC" className="modal modalTC modal-fixed-footer">
            <div
                className="modal-content modalTCContent"
                ref={contentRef}
                onScroll={handleScroll}
            >
                <div className="row mb-0">
                    <div className="col s12">
                        <div className="row mb-0" style={{ position: 'fixed', width: '100%', background: '#FFFFFF', zIndex: 1 }}>
                            <div className="col s12 left-align mt-1" style={{ paddingLeft: '2rem' }}>
                                <span className="ft-18 txt_main-dark-blue txtBold">Información Legal</span>
                            </div>
                            <div className="col s12 mt-1 card_fondo">
                                <div className="divider" />
                            </div>
                        </div>
                    </div>

                    <div className="col s12">
                        <div className="row mb-0" style={{ background: '#F6F8FA', marginTop: '4rem' }}>
                            <div className="col s4 left-align" style={{ paddingLeft: '2rem' }}>
                                <div style={{ position: 'fixed', width: 'inherit' }}>
                                    <p className={`cursorPointer ft-14 ${optSelected === 1 ? 'txt_main-dark-blue txtBold' : 'labelNavy'}`}
                                        onClick={() => {
                                            handleTabChange(1)
                                        }}
                                    >1. Aviso de Privacidad</p>
                                    <p className={`cursorPointer ft-14 ${optSelected === 2 ? 'txt_main-dark-blue txtBold' : 'labelNavy'}`}
                                        onClick={() => {
                                            handleTabChange(2)
                                        }}
                                    >2. Términos y Condiciones</p>
                                </div>
                            </div>
                            <div className="col s8">
                                <div className="row mb-0" style={{ background: '#FFFFFF' }}>
                                    <div className="col s12 mt-1">
                                        <div
                                            style={{
                                                backgroundColor: '#EEF8F9',
                                                border: '1px solid #41BBC9',
                                                borderRadius: '8px',
                                                padding: '12px 16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginBottom: '1rem',
                                            }}
                                        >
                                            <i
                                                className="material-icons"
                                                style={{
                                                    color: '#41BBC9',
                                                    marginRight: '12px',
                                                    fontSize: '24px',
                                                }}
                                            >
                                                info_outline
                                            </i>
                                            <span
                                                style={{
                                                    color: '#4D5575',
                                                    fontSize: '14px',
                                                    lineHeight: '1.4',
                                                }}
                                            >
                                                Es necesario leer y aceptar los Términos y Condiciones y el Aviso de Privacidad para ingresar a la aplicación.
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col s12 mt-1">
                                        {
                                            optSelected === 1 ?
                                                <AvisoDePrivacidad />

                                                : <Terminos />
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="modal-footer">
                <div className="row mb-0">
                    <div className="col s12 left-align" style={{ paddingTop: '6px' }}>
                        <label>
                            <input
                                type="checkbox"
                                className="filled-in"
                                disabled={!scrolledAviso}
                                checked={aceptoAviso}
                                onChange={(e) => setAceptoAviso(e.target.checked)}
                            />
                            <span style={{ color: scrolledAviso ? '#33445F' : '#797F97' }} className="ft-14">He leído y acepto los <span className="txtBold">Aviso de Privacidad</span></span>
                        </label>
                    </div>
                    
                    <div className="col s12 left-align" style={{ paddingTop: '6px' }}>
                        <label>
                            <input
                                type="checkbox"
                                className="filled-in"
                                disabled={!scrolledTerminos}
                                checked={aceptoTerminos}
                                onChange={(e) => setAceptoTerminos(e.target.checked)}
                            />
                            <span style={{ color: scrolledTerminos ? '#33445F' : '#797F97' }} className="ft-14">He leído y acepto el <span className="txtBold">Términos y Condiciones</span></span>
                        </label>
                    </div>
                </div>
                <div className="row mb-0 mt-1">
                    <div className="col s12 right-align">
                        <button className="btn btnRechazarTC"
                            onClick={() => {
                                resetState();
                                const modalTC = M.Modal.getInstance(document.getElementById('modalTC'));
                                if (modalTC) {
                                    modalTC.close();
                                }
                                dispatch(setUser(false));
                            }}
                            disabled={cargando}
                        > Cerrar sesión </button>
                        <button className="btn btnContinuarTC waves-effect"
                            disabled={cargando || !aceptoAviso || !aceptoTerminos}

                            style={{ marginLeft: '2rem' }}
                            onClick={() => {
                                aceptarTerminos();
                            }}
                        > Guardar y continuar </button>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default ModalTC;